import { render, staticRenderFns } from "./copy-template.vue?vue&type=template&id=8aca1bba"
import script from "./copy-template.vue?vue&type=script&lang=js"
export * from "./copy-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports